<div class="row my-4">
  <div class="col-6 d-flex">
    <div class="form-group me-5">
      <div class="icon-wrapper">
        <form [formGroup]="searchForm">
          <select class="form-control" formControlName="courseBrandId">
            <option [ngValue]="null">{{ 'Filter by course group' | translate }}</option>
            <option class="option" *ngFor="let option of courseGroups$ | async" [value]="option.id">
              {{ option.name }}
            </option>
          </select>
          <fa-icon [icon]="['far', 'sliders-simple']" size="sm"></fa-icon>
        </form>
      </div>
    </div>
    <button class="btn btn-primary btn-search" (click)="search()">{{ 'Search' | translate }}</button>
  </div>
  <div class="col-6 d-flex justify-content-end" *ngIf="needToggle">
    <app-pcsd-toggle-button-group [(isPcsd)]="isPcsd"></app-pcsd-toggle-button-group>
  </div>
</div>
<div class="row my-4">
  <div class="col-12 d-flex">
    <div>
      <span class="showing">{{ 'Showing results for' | translate }}: </span> <span>{{ currentCourseGroup?.name }}</span>
    </div>
    <div class="ms-3 clear-results" (click)="clear()">{{ 'Clear results' | translate }}</div>
  </div>
</div>
<div class="row mb-2" *ngIf="splitIsgIdgCourse && primaryCourses">
  <div class="col-12 d-flex bold">
    <div>
      {{ 'ISG Independent courses' | translate }}
    </div>
  </div>
</div>
<div class="row" *ngIf="primaryCourses">
  <div class="col-12">
    <lib-generic-list
      [dataProvider]="primaryCourses"
      [columnsProvider]="primaryCourseListColumnsProvider"
      [showPagination]="false"
      [pageSize]="500"
    >
      <ng-container *libGenericListCustomItemRenderer="'name'; let row">
        <div
          class="bold"
          *ngIf="
            row.name === 'Mandatory' ||
            row.name === 'Optional' ||
            row.name === 'Learning paths' ||
            row.name === 'Courses'
          "
        >
          {{ row.name | translate }}
        </div>
        <div
          *ngIf="
            row.name !== 'Mandatory' &&
            row.name !== 'Optional' &&
            row.name !== 'Learning paths' &&
            row.name !== 'Courses'
          "
        >
          {{ row.name }}
        </div>
      </ng-container>
      <ng-container *libGenericListCustomItemRenderer="'takeCourse'; let row">
        <a
          class="btn btn-primary"
          target="_blank"
          [href]="row.externalUrl"
          *ngIf="
            row.courseCompletionDate === null &&
            !row.isCompleted &&
            row.name !== 'Mandatory' &&
            row.name !== 'Optional' &&
            row.name !== 'Learning paths' &&
            row.name !== 'Courses'
          "
        >
          {{ 'Take the course' | translate }}
        </a>
        <span *ngIf="row.courseCompletionDate !== null && row.isCompleted"
          >{{ 'Course completed on' | translate }} {{ row.courseCompletionDate | date: programDateFormat }}</span
        >
      </ng-container>
    </lib-generic-list>
  </div>
</div>
<ng-container *ngIf="splitIsgIdgCourse && secondaryCourses">
  <div class="row mb-2 mt-3">
    <div class="col-12 d-flex bold">
      <div>
        {{ 'IDG Independent courses' | translate }}
      </div>
    </div>
  </div>
  <div class="row" *ngIf="secondaryCourses">
    <div class="col-12">
      <lib-generic-list
        [dataProvider]="secondaryCourses"
        [columnsProvider]="secondaryCourseListColumnsProvider"
        [showPagination]="false"
        [pageSize]="500"
      >
        <ng-container *libGenericListCustomItemRenderer="'name'; let row">
          <div
            class="bold"
            *ngIf="
              row.name === 'Mandatory' ||
              row.name === 'Optional' ||
              row.name === 'Learning paths' ||
              row.name === 'Courses'
            "
          >
            {{ row.name | translate }}
          </div>
          <div
            *ngIf="
              row.name !== 'Mandatory' &&
              row.name !== 'Optional' &&
              row.name !== 'Learning paths' &&
              row.name !== 'Courses'
            "
          >
            {{ row.name }}
          </div>
        </ng-container>
        <ng-container *libGenericListCustomItemRenderer="'takeCourse'; let row">
          <a
            class="btn btn-primary"
            target="_blank"
            [href]="row.externalUrl"
            *ngIf="
              row.courseCompletionDate === null &&
              !row.isCompleted &&
              row.name !== 'Mandatory' &&
              row.name !== 'Optional' &&
              row.name !== 'Learning paths' &&
              row.name !== 'Courses'
            "
          >
            {{ 'Take the course' | translate }}
          </a>
          <span *ngIf="row.courseCompletionDate !== null && row.isCompleted"
            >{{ 'Course completed on' | translate }} {{ row.courseCompletionDate | date: programDateFormat }}</span
          >
        </ng-container>
      </lib-generic-list>
    </div>
  </div>
</ng-container>
